/* eslint-disable no-template-curly-in-string */
/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line import/no-unresolved
import { ReactComponent as EcoIcon } from '@assets/icons/eco.svg';
import { Button } from '@lesmills-international/components';
import { navigate } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import React, { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { getConvertedPrice, getPlanId, getPlanPeriod } from '@src/utils';
import { StepLabel } from '../../../types/DataTracking';
import { registrationFlowTracking } from '../../../utils/dataTracking';
import SpinnerLogo from '../../common/spinnerLogo/SpinnerLogo';
import {
  AlertDescription,
  AlertTitle,
  AlertWrapper,
  ButtonWrapper,
  ProcessingMessage,
  SuccessMessage,
  Title,
  WelcomeMessage,
  Wrapper,
} from './styles';

const Success = ({
  data,
  handleStarted,
  handleRetryRefresh,
  location,
  selectedPlan,
  newSubscription,
  userInfo,
  isTokenRefreshing,
  tokenRefreshFailed,
}) => {
  const { page_title, description, get_started, dont_refresh, alert_title, alert_description } =
    data;

  const [userEmail, setUserEmail] = useState('');
  const [trackingReady, setTrackingReady] = useState(false);
  const { email, familyName, givenName } = userInfo || {};

  const handleTrackingReady = useCallback(() => {
    setTrackingReady(true);
  }, []);

  const trackRegistrationFlowEvent = useCallback(() => {
    const { name, tier, currency, product_price_point } = selectedPlan || {};
    const { interval, interval_unit, price_in_cents } = product_price_point || {};
    const { state } = location || {};
    const discountInfo = state?.discountInfo;

    if (trackingReady) {
      return;
    }

    registrationFlowTracking({
      planName: name,
      stepLabel: StepLabel.CONVERSION_SUCCESS,
      planTier: tier?.internal_tier_id,
      planBillingFreq: getPlanPeriod(interval, interval_unit),
      currency,
      planPrice: getConvertedPrice(price_in_cents, currency).toString(),
      customerEmail: email,
      customerFirstName: givenName,
      customerLastName: familyName,
      planId: getPlanId(discountInfo, selectedPlan),
      eventCallBack: handleTrackingReady,
    });
  }, [selectedPlan, handleTrackingReady, givenName, familyName, email, location, trackingReady]);

  useEffect(() => {
    const initializePageTracking = async () => {
      if (!newSubscription || !userInfo) {
        navigate('/signup/create-account/');
      }
      setUserEmail(email);
      trackRegistrationFlowEvent();
    };
    initializePageTracking();
  }, [trackRegistrationFlowEvent, email, userInfo, newSubscription]);

  return (
    <Wrapper id="successWrapper">
      {tokenRefreshFailed ? (
        <>
          <Title>{page_title}</Title>
          <SuccessMessage>{description.replace('${userEmail}', userEmail)}</SuccessMessage>
          <WelcomeMessage role="status" aria-live="polite">
            Your account is being set up. This may take a moment.
          </WelcomeMessage>
          <ButtonWrapper id="success-button-wrapper">
            <Button
              ctaButton
              style={{ width: '100%' }}
              onClick={handleRetryRefresh}
            >
              Try again
            </Button>
          </ButtonWrapper>
        </>
      ) : trackingReady ? (
        <>
          <Title>{page_title}</Title>
          <SuccessMessage>{description.replace('${userEmail}', userEmail)}</SuccessMessage>
          <WelcomeMessage>Ready to start your fitness journey?</WelcomeMessage>
          <ButtonWrapper id="success-button-wrapper">
            <Button
              ctaButton
              style={{ width: '100%' }}
              onClick={handleStarted}
              loading={isTokenRefreshing}
            >
              {get_started}
            </Button>
          </ButtonWrapper>
          <AlertWrapper>
            <div>
              <EcoIcon />
            </div>
            <div>
              <AlertTitle>{alert_title.text}</AlertTitle>
              <AlertDescription>
                <RichText render={alert_description.richText} />
              </AlertDescription>
            </div>
          </AlertWrapper>
        </>
      ) : (
        <>
          <SpinnerLogo />
          <ProcessingMessage>{dont_refresh}</ProcessingMessage>
        </>
      )}
    </Wrapper>
  );
};

export default Success;
